import { Box } from "@chakra-ui/layout"
import { AdvancedMarker } from "@vis.gl/react-google-maps"
import React from "react"
import Polyline from "../gmaps/Polyline"
import { LatLngObj } from "../lib/helpers/googleMap"
import { TripEntity } from "../lib/types/trip"
import { ReactComponent as TripA } from "../assets/images/trip-a.svg"
import { ReactComponent as TripB } from "../assets/images/trip-b.svg"
import { useTripsStyle } from "../lib/hooks/useTripsStyle"

interface TripLayerGoogleMapProps {
  mapId: string
  trip: TripEntity
  isSelected: boolean
  onSelectTrip: (trip: TripEntity) => void
  zIndex?: number
}

const BlackCircle: React.FC<{
  backgroundColor: string
}> = ({ backgroundColor }) => (
  <Box h="10px" w="10px" backgroundColor={backgroundColor} opacity={0.7} borderRadius="50%" />
)

const TripLayerGoogleMap: React.FC<TripLayerGoogleMapProps> = ({
  mapId,
  trip,
  isSelected,
  onSelectTrip,
  zIndex,
}) => {
  const [isHovered, setIsHovered] = React.useState<boolean>(false)
  const tripsStyle = useTripsStyle()

  const tripPath = trip?.route?.coordinates.map((coord) => ({
    lng: coord[0],
    lat: coord[1],
  })) as LatLngObj[]

  const firstCenter = {
    lng: trip?.route?.coordinates[0][0],
    lat: trip?.route?.coordinates[0][1],
  } as LatLngObj

  const secondCenter = {
    lng: trip?.route?.coordinates[trip.route.coordinates.length - 1][0],
    lat: trip?.route?.coordinates[trip.route.coordinates.length - 1][1],
  } as LatLngObj

  return (
    <>
      <Polyline
        mapId={mapId}
        path={tripPath}
        strokeOptions={{
          strokeColor: isHovered || isSelected ? tripsStyle.color["800"] : tripsStyle.color["500"],
          strokeOpacity: isHovered || isSelected ? 1 : tripsStyle.opacity,
          strokeWeight: 5,
        }}
        {...(zIndex ? { zOptions: { zIndex } } : {})}
        onClick={() => onSelectTrip(trip)}
        onMouseOver={() => setIsHovered(true)}
        onMouseOut={() => setIsHovered(false)}
        addBorder
        borderColor={tripsStyle.color["900"]}
      />

      <AdvancedMarker position={firstCenter}>
        {isSelected ? <Box as={TripA} h="26px" /> : <BlackCircle backgroundColor={tripsStyle.color["900"]} />}
      </AdvancedMarker>

      <AdvancedMarker position={secondCenter}>
        {isSelected ? <Box as={TripB} h="26px" /> : <BlackCircle backgroundColor={tripsStyle.color["900"]} />}
      </AdvancedMarker>
    </>
  )
}

export default TripLayerGoogleMap
